var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 3H3a3 3 0 00-3 3v12a3 3 0 003 3h18a3 3 0 003-3V6a3 3 0 00-3-3z",
    fill: "#32BCAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.581 15.18c-.482 0-.935-.183-1.276-.516l-1.843-1.8a.356.356 0 00-.484 0l-1.85 1.806c-.34.333-.794.517-1.276.517H8.49l2.334 2.28c.729.711 1.91.711 2.64 0l2.34-2.287h-.222zM8.852 8.813c.482 0 .936.184 1.277.517l1.85 1.806c.132.13.35.13.483 0l1.843-1.8c.34-.333.794-.516 1.276-.516h.222l-2.34-2.286a1.898 1.898 0 00-2.64 0L8.49 8.814h.363z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.74 10.71l-1.415-1.38a.275.275 0 01-.1.02h-.644c-.332 0-.658.131-.893.36l-1.842 1.8a.892.892 0 01-.626.253.893.893 0 01-.625-.252l-1.85-1.807a1.286 1.286 0 00-.893-.361h-.79a.274.274 0 01-.095-.02l-1.42 1.388a1.793 1.793 0 000 2.578l1.42 1.387a.273.273 0 01.095-.019h.79c.333 0 .658-.131.893-.361l1.85-1.806a.922.922 0 011.25 0l1.843 1.8c.235.229.56.36.893.36h.643c.036 0 .07.008.1.02l1.415-1.38a1.793 1.793 0 000-2.58",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPix);
export default __webpack_public_path__ + "static/media/pix.15d729468126c76de8a251cc92b52d87.svg";
export { ForwardRef as ReactComponent };